export const MEDICINES_ROUTES = {
  generalRecipe             : 'recetas/general',
  masterRecipe              : 'recetas/magistral',
  diabetesRecipe            : 'recetas/diabetes',
  historyPatientRecipes     : 'historial/recetas/paciente',
  historyProfessionalRecipes: 'historial/recetas/profesional',
};
